import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

export default function ApprovalAccessCard() {
    return (
        <Box sx={{ maxWidth: 960, mx: 'auto', mt: 6 }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" gutterBottom>
                        Kein Zugriff
                    </Typography>
                    <Typography>Für die Freigabeworkflows wird die Berechtigung &quot;approval:read&quot; benötigt.</Typography>
                </CardContent>
            </Card>
        </Box>
    );
}
